import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';
import { IRoom } from '../types/room';

interface IDeleteUserResponse {
  deletedRooms: IRoom[];
  success: boolean;
}

export const deleteUser = async ({ userId }: { userId: string }): Promise<AxiosResponse<IDeleteUserResponse>> =>
  AxiosInstance.post('users.delete', { userId, confirmRelinquish: true });
